import React from 'react';
import { Typography, Box } from '@mui/material';
import EventSelect from './EventSelect';
import BusinessProfileSelect from './BuisnessProfileSelect';
import SelectedItems from '../../../components/SelectedItems';
import { WEBHOOK_EVENTS } from '../../../constants/webhookEvents';

const WebhookScopeModal = ({ formData, isLoading, setFormData, profiles, totalProfiles, isGlobal }) => {
  return (
    <Box
      sx={{
        maxHeight: '40vh',
        overflowY: 'auto',
        pr: 1,
      }}
    >
      {!isGlobal && (
        <Box>
          <Typography mb={1}>Business Profile Scope *</Typography>
          <BusinessProfileSelect
            profiles={profiles}
            isLoading={isLoading}
            selected={formData.businessProfiles}
            totalProfiles={totalProfiles}
            onChange={(ids) =>
              setFormData((prev) => ({
                ...prev,
                businessProfiles: ids,
              }))
            }
          />
          <SelectedItems
            items={formData.businessProfiles}
            getLabel={(profile_id) => {
              const profile = profiles.find((p) => p.profile_id === profile_id);
              if (!profile) return profile_id;
              return `${profile.name} | ${profile.tin}`;
            }}
            onRemove={(id) =>
              setFormData((prev) => ({
                ...prev,
                businessProfiles: prev.businessProfiles.filter((v) => v !== id),
              }))
            }
          />
        </Box>
      )}

      <Box mt={3}>
        <Typography mb={1}>Events *</Typography>

        <EventSelect
          events={WEBHOOK_EVENTS}
          selected={formData.events}
          onChange={(events) =>
            setFormData((prev) => ({
              ...prev,
              events,
            }))
          }
        />

        <SelectedItems
          items={formData.events}
          getLabel={(event) => event.replace(/([a-z])([A-Z])/g, '$1.$2').toLowerCase()}
          onRemove={(event) =>
            setFormData((prev) => ({
              ...prev,
              events: prev.events.filter((v) => v !== event),
            }))
          }
        />
      </Box>
    </Box>
  );
};

export default WebhookScopeModal;
